<template>
    <div class="cc-delivery-address-summary">
        <div class="cc-delivery-address-summary__header">
            <div class="cc-delivery-address-summary__title" v-if="!pickupInStore">{{ translations['Delivery address summary'] }}</div>
            <div class="cc-delivery-address-summary__title" v-if="pickupInStore">{{ translations['Contact details summary'] }}</div>
        </div>
        <div class="cc-delivery-address-summary__main">
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.firstname">{{ deliveryAddress.firstname }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.lastname">{{ deliveryAddress.lastname }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.addressLine1 && pickupInStore === false">{{ deliveryAddress.addressLine1 }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.city && pickupInStore === false">{{ deliveryAddress.city }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.country && pickupInStore === false">{{ countryName }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.postalCode && pickupInStore === false">{{ deliveryAddress.postalCode }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.phone">{{ deliveryAddress.phone }}</div>
            <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.email">{{ deliveryAddress.email }}</div>
            <div class="cc-delivery-address-summary__group" v-if="isCompanyInformationEntered">
                <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.company">{{ deliveryAddress.company }}</div>
                <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.identificationNumber">{{ deliveryAddress.identificationNumber }}</div>
                <div class="cc-delivery-address-summary__item" v-if="deliveryAddress.taxIdentificationNumber">{{ deliveryAddress.taxIdentificationNumber }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                currentCarrier: state => state.currentCarrier,
                deliveryAddress: state => state.user.deliveryAddress,
                countries: state => state.config.countries,
                showCompanyInformation: state => state.user.showCompanyInformation,
            }),
            pickupInStore: function () {
                return this.currentCarrier.pickupInStore
            },
            countryName: function() {
                for (let key in this.countries) {
                    if (!this.countries.hasOwnProperty(key)) {
                        continue;
                    }

                    if (this.countries[key].id === this.deliveryAddress.country) {
                        return this.countries[key].name;
                    }
                }

                return '';
            },
            isCompanyInformationEntered: function () {
                return this.showCompanyInformation;
            },
        },
        name: 'DeliveryAddressSummary',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-delivery-address-summary {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-delivery-address-summary__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-delivery-address-summary__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-delivery-address-summary__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }

        .cc-delivery-address-summary__group {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
